import { ISidebarConfig, ISidebarSection } from '../components/sidebar-menu/sidebar-menu.interface';
import { BASE_SIDEBAR_SECTION } from './base.config';

export const GUARD_SIDEBAR_SECTION: ISidebarSection = {
    id: 'surveillance',
    title: 'Vigilantes',
    items: [
        {
            id: 'shifts',
            title: 'Turnos',
            route: '/turno',
            icon: 'briefcase',
            isVisible: true,
        },
        {
            id: 'reports',
            title: 'Relatórios',
            icon: 'report',
            children: [
                {
                    id: 'occurrence-report',
                    title: 'Relatório de Ocorrência',
                    route: '/relatorio-ocorrencia',
                    isVisible: true,
                },
                {
                    id: 'occurrence-dispatch',
                    title: 'Despacho de Ocorrência',
                    route: '/despacho-ocorrencia',
                    isVisible: true,
                },
                {
                    id: 'motorized-service-report',
                    title: 'Relatório de Ser. Motorizado',
                    route: '/relatorio-servico-motorizado',
                    isVisible: true,
                },
                {
                    id: 'fuel-control',
                    title: 'Cadastro de Abastecimento',
                    route: '/cadastro-abastecimento',
                    isVisible: true,
                },
                {
                    id: 'send-doc-admin',
                    title: 'Enviar Documento',
                    // route: '/Enviar DOC para Administração',
                    route: '/enviar-documento',
                    isVisible: true,
                },
            ],
            isVisible: true,
        },
        {
            id: 'checklists',
            title: 'Checklists',
            icon: 'security',
            children: [
                {
                    id: 'motorcycle-checklist',
                    title: 'Checklist Moto',
                    route: '/checklist-moto',
                    isVisible: true,
                },
                {
                    id: 'vehicle-checklist',
                    title: 'Checklist Viatura',
                    route: '/checklist-veiculo',
                    isVisible: true,
                },
                {
                    id: 'doorman-checklist',
                    title: 'Checklist Portaria',
                    route: '/checklist-porteiro',
                    isVisible: true,
                },
                {
                    id: 'armament-checklist',
                    title: 'Checklist Armamento',
                    route: '/checklist-armamento',
                    isVisible: true,
                },
            ],
            isVisible: true,
        },
        {
            id: 'patrol',
            title: 'Rondas',
            route: '/ronda',
            icon: 'patrol',
            isVisible: true,
        },
        {
            id: 'panic-events',
            title: 'Eventos de Pânico',
            route: '/eventos-panico',
            icon: 'alert',
            isVisible: true,
        },
    ],
    isVisible: true,
};

export const GUARD_SIDEBAR_CONFIG: ISidebarConfig = {
    role: 'GUARD',
    sections: [BASE_SIDEBAR_SECTION, GUARD_SIDEBAR_SECTION],
};
